export function getErrorMessage(error: unknown, fallback = 'Erro inesperado'): string {
  if (error instanceof Error) return error.message;

  if (isRecord(error) && typeof error.message === 'string') {
    return error.message;
  }

  return fallback;
}

export function getErrorDebugInfo(error: unknown): Record<string, unknown> {
  if (!isRecord(error)) return { error };

  return {
    message: error.message,
    details: error.details,
    hint: error.hint,
    code: error.code,
  };
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

